const actions = {
  CREATE_BRIEF_TERM: 'CREATE_BRIEF_TERM',
  CREATE_BRIEF_TERM_ENDED: 'CREATE_BRIEF_TERM_ENDED',
  SEARCH_BRIEF_TERMS: 'SEARCH_BRIEF_TERMS',
  SEARCH_BRIEF_TERMS_ENDED: 'SEARCH_BRIEF_TERMS_ENDED',
  DELETE_BRIEF_TERM: 'DELETE_BRIEF_TERM',
  DELETE_BRIEF_TERM_ENDED: 'DELETE_BRIEF_TERM_ENDED',
  CREATE_BRIEF_TERM_CONTENT: 'CREATE_BRIEF_TERM_CONTENT',
  CREATE_BRIEF_TERM_CONTENT_ENDED: 'CREATE_BRIEF_TERM_CONTENT_ENDED',
  SEARCH_BRIEF_TERM_CONTENTS: 'SEARCH_BRIEF_TERM_CONTENTS',
  SEARCH_BRIEF_TERM_CONTENTS_ENDED: 'SEARCH_BRIEF_TERM_CONTENTS_ENDED',
  FIND_BRIEF_TERM_CONTENT: 'FIND_BRIEF_TERM_CONTENT',
  FIND_BRIEF_TERM_CONTENT_ENDED: 'FIND_BRIEF_TERM_CONTENT_ENDED',
  UPDATE_BRIEF_TERM_CONTENT: 'UPDATE_BRIEF_TERM_CONTENT',
  UPDATE_BRIEF_TERM_CONTENT_ENDED: 'UPDATE_BRIEF_TERM_CONTENT_ENDED',
  DELETE_BRIEF_TERM_CONTENTS: 'DELETE_BRIEF_TERM_CONTENTS',
  DELETE_BRIEF_TERM_CONTENTS_ENDED: 'DELETE_BRIEF_TERM_CONTENTS_ENDED',
  FETCH_BRIEF_TERM_TYPES: 'FETCH_BRIEF_TERM_TYPES',
  FETCH_BRIEF_TERM_TYPES_ENDED: 'FETCH_BRIEF_TERM_TYPES_ENDED',
};

export default actions;
